import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=1cd31574&"
import script from "./Admin.vue?vue&type=script&setup=true&lang=js&"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports